module.exports = __webpack_public_path__ + "img/info-square.671ac144.svg";